import React, {  useState } from "react";
import {  doc, updateDoc } from "firebase/firestore";
import { db } from "../api/firebase";
import { useDocumentData } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";
// redux - use
import { useNotification } from "../redux/useNotification";

const DeleteReview = ({ setOpen, requestId }) => {
  const { id } = useParams();
    // redux - Notification
    const { displayNotification } = useNotification();

  // 評価取得関連
  const [review] = useDocumentData(
    doc(db, "products", id, "review", requestId)
  );
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //   削除処理
  const handleDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 削除
      await updateDoc(doc(db, "products", id, "review", requestId),{
        display:false
      });
      setOpen(false);
      displayNotification({
        message: "レビューを非表示にしました。",
        type:"success"
      });
  
      // window.location.reload();
    } catch (err) {
      setLoading(false);
      setError(err);
      console.log(err);
    }
  };
  return (
    <>
      <div className="mb-3 bg-blue-500 text-white p-1 rounded-full text-center">
        レビュー非表示
      </div>
      <form onSubmit={(e) => e.preventDefault()}>

        <div className="font-bold text-2xl">以下のレビューを非表示にします</div>
        <div className="border-2 p-2 rounded-md mb-2">
          <div className="text-gray-300">レビュー</div>
          <div>{review?.review}</div>
        </div>
        <button
          data-mdb-ripple="true"
          data-mdb-ripple-color="light"
          className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
          disabled={loading}
          onClick={handleDelete}
        >
          {loading ? "非表示にしています..." : "非表示にする"}
        </button>
        {error ? error : ""}
      </form>
    </>
  );
};

export default DeleteReview;
